export default __webpack_public_path__ + "static/char-s-10-chs-4e7f3140c9a375c43655ed451e6bf02d.webp";